import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.007 1.902a.67.67 0 0 1 .66-.572h6.666c.332 0 .613.244.66.572l.666 4.659a1 1 0 0 1 .008.102c0 2.274-1.84 3.716-4 3.963v2.704h2a.667.667 0 1 1 0 1.333H5.333a.667.667 0 0 1 0-1.333h2v-2.704c-2.156-.247-3.992-1.683-4-3.948q0-.06.009-.12zm.684 5.105C4.879 8.347 6.169 9.33 8 9.33c1.41 0 2.5-.583 3.012-1.463a4 4 0 0 1-3.412-.67 2.67 2.67 0 0 0-2.91-.19m6.589-.67A2.67 2.67 0 0 1 8.4 6.13a4 4 0 0 0-3.56-.628l.405-2.839h5.51z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })